import React, { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import WizardButtonList from '../WizardButtonList';
import WizardNavigation from '../WizardNavigation';
import Aux from '../../../hoc/Aux';
import WizardStandardHeader from '../WizardStandardHeader';
import WizardStandardSubHeader from '../WizardStandardSubHeader';
import { axiosProtected } from '../../../axios-wizard';
import { useTranslation } from 'react-i18next';

const wizardStepDefault = (props) => {

  if (props.currentStep !== props.stepName) {
    return null;
  }

  const { t } = useTranslation();

  const [buttons, setButtons] = useState([]);

  const dispatch = useDispatch();
  const onSelect = useCallback(
      (stepValue) => dispatch(props.onSelectAction(stepValue)),
      [dispatch]
    )

  useEffect(() => {
      const fetchData = async () => {
        const result = await axiosProtected(
          props.getButtonsUrl,
        );

        setButtons(result.data);
      };
      fetchData();
    }, []);

  return(

    <Aux>

      <WizardStandardHeader>
        <WizardNavigation />
      </WizardStandardHeader>

      <div className="row justify-content-center content-list-head">
        <div className="col-lg-11 col-xl-11">
          <WizardStandardSubHeader
            display={true}
            modalTitle={ t('wizard.steps.'+ props.stepName +'.modaltitle') }
            title={t('wizard.steps.'+ props.stepName +'.title')}
            modalTextToken={ props.modalTextToken } />
        </div>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-11 col-xl-11">
          <div className="row">
            <WizardButtonList buttons={buttons} stepName={props.stepName} onClick={onSelect} dividerEnabled={props.dividerEnabled}/>
          </div>
        </div>
      </div>

    </Aux>
 );
};

export default wizardStepDefault;



// WEBPACK FOOTER //
// ./src/components/Wizard/Steps/WizardStepDefault.js